export const IMAGE_TYPE = {
  AWS_S3: 's3',
  EBAY: 'ebayimg',
  ETSY: 'etsy',
  FAIRE: 'faire',
  LOCAL: 'local',
  SHOPIFY: 'shopify',
  UNSPLASH: 'unsplash',
};

export const MIME = {
  PNG: 'image/png',
  GIF: 'image/gif',
  HEIC: 'image/heic',
  JPG: 'image/jpeg',
  TIFF: 'image/tiff',
  WEBP: 'image/webp',
  QUICKTIME: 'video/quicktime',
};

export const EXT = {
  PNG: 'png',
  GIF: 'gif',
  HEIC: 'heic',
  JPG: 'jpg',
  JPEG: 'jpeg',
  TIFF: 'tiff',
  WEBP: 'webp',
};

export const MIME_TO_EXT = {
  [MIME.PNG]: EXT.PNG,
  [MIME.GIF]: EXT.GIF,
  [MIME.HEIC]: EXT.HEIC,
  [MIME.JPG]: EXT.JPG,
  [MIME.TIFF]: EXT.TIFF,
  [MIME.WEBP]: EXT.WEBP,
};

export const EXT_TO_MIME = {
  [EXT.PNG]: MIME.PNG,
  [EXT.GIF]: MIME.GIF,
  [EXT.HEIC]: MIME.HEIC,
  [EXT.JPG]: MIME.JPG,
  [EXT.JPEG]: MIME.JPG,
  [EXT.TIFF]: EXT.TIFF,
  [EXT.WEBP]: MIME.WEBP,
};

export const CROSS_ORIGIN = {
  ANONYMOUS: 'anonymous',
};
